// normalize to transformer
export const validatorsMapping = {
  required: 'required',
  requiredValue: 'requiredValue',
  minLength: 'minLength',
  maxLength: 'maxLength',
  regexp: 'regex',
  birthdate: 'isOlderThan',
  daysFromNow: 'daysFromNow',
  date: 'isValidDate',
  zipcode: 'isValidPostalCode',
  email: 'isValidEmail',
  iban: 'isValidIBAN',
  phone: 'isPhoneNumber',
  mobilephone: 'isPhoneNumber',
  mobilephoneNormalized: 'isPhoneNumberNormalized',
  phoneNormalized: 'isPhoneNumberNormalized',
  minDays: 'minDays',
  isFutureDate: 'isFutureDate',
  isTruthy: 'isTruthy',
  dateDistanceFuture: 'dateDistance',
  dateDistancePast: 'dateDistance',
  requiredIfLicensePlateHasValue: 'requiredIfLicensePlateHasValue',
};

export default validatorsMapping;
